import { ACTION_STATUSES } from 'lib/core/actionStatuses';

import SETTINGS_ACTION_TYPES from 'modules/SRMT/Settings/store/actions/settings/types';
import { initialSectionState } from 'store/reducers/initialStates';
import type { SettingsState } from 'modules/SRMT/Settings/store/types';

const initialState = (): SettingsState => ({
  enabledPartners: initialSectionState()
});

const actionManager = {
  [SETTINGS_ACTION_TYPES.FETCH_ENABLED_PARTNERS]: (state: SettingsState): SettingsState => ({
    ...state,
    enabledPartners: {
      status: ACTION_STATUSES.PENDING,
      error: null,
      data: null
    }
  }),
  [SETTINGS_ACTION_TYPES.SET_FETCH_ENABLED_PARTNERS_SUCCESS]: (state: SettingsState, payload): SettingsState => ({
    ...state,
    enabledPartners: {
      status: ACTION_STATUSES.SUCCEED,
      data: payload.data,
      error: null
    }
  }),
  [SETTINGS_ACTION_TYPES.SET_FETCH_ENABLED_PARTNERS_FAILURE]: (state: SettingsState, payload): SettingsState => ({
    ...state,
    enabledPartners: {
      status: ACTION_STATUSES.FAILED,
      data: null,
      error: payload.error
    }
  }),
  [SETTINGS_ACTION_TYPES.CLEAR_ENABLED_PARTNERS_STATE]: (state: SettingsState): SettingsState => ({
    ...state,
    enabledPartners: initialSectionState()
  })
};

export default {
  actionManager,
  initialState
};
